import { ref } from 'vue'
import { defineStore } from 'pinia'
import axios from '@/plugins/axios.js';

export const productStore = defineStore('product', () => {
  var products = ref()
  var dataColors = ref()
  var dataSpecific = ref()
  var dataSizes = ref()
  var detailProduct = ref()

  /*PRODUCT*/
  const getDetailProduct = () => {
    return detailProduct.value;
  }

  const setDetailProduct = (value) => {
    detailProduct.value = value;
  }


  const setProducts = (data) => {
    products.value = data;
  }

  const getProducts = () => {
    return products.value;
  }

  /**
   * Function used to obtain with axios all available products in the data base
   * @returns List of available products
   */
  const getAllProducts = async () => {
    try {
      await axios.get('/products.php', {
        params: {
          "type": "all"
        }
      }, {
      }).then(response => {
        if (response.status == 200) {
          setProducts(response['data']);
        } else {
          console.log('redirigir a página de "NO ENCONTRADO"')
        }
      })
    } catch (error) {
      console.error("Hubo un error en la solicitud: ", error);
    } finally {
      return getProducts();
    }
  }


  /**
   * Function used to obtain variant sizes to product. The variants sizes depend of color
   * @param {*} id General id product
   * @param {*} color Product color
   */
  const getSizeVariants = async (id, color) => {
    try {
      await axios.get('/products.php', {
        params: {
          "id": id,
          "color": color,
          "type": 'sizes'
        }
      }).then(response => {
        if (response.status == 200) {
          dataSizes.value = response['data']
        }
      })
    } catch (error) {
      console.error("Hubo un error en la solicitud: ", error);
    } finally {
      return dataSizes.value
    }
  }

  /**
     * Function used to obtain variant colors to product. The variants sizes depend of id
     * @param {*} id General id product
     * @param {*} color Current product color
     */
  const getProductColors = async (id, color) => {
    try {
      await axios.get('/products.php', {
        params: {
          "id": id,
          "color": color,
          "type": 'colors'
        }
      }).then(response => {
        if (response.status == 200) {
          dataColors.value = response['data']
        }
      })
    } catch (error) {
      console.error("Hubo un error en la solicitud: ", error);
    } finally {
      return dataColors.value
    }
  }

  /**
     * Function used to obtain variant colors to product. The variants sizes depend of id
     * @param {*} id General id product
     * @param {*} color Current product color
     */
  const getSpecificProduct = async (id, color) => {
    try {
      await axios.get('/products.php', {
        params: {
          "id": id,
          "color": color,
          "type": 'specific'
        }
      }).then(response => {
        if (response.status == 200) {
          dataSpecific.value = response['data']
        }
      })
    } catch (error) {
      console.error("Hubo un error en la solicitud: ", error);
    } finally {
      return dataSpecific.value
    }
  }

  return {
    getDetailProduct,
    setDetailProduct,
    getAllProducts,
    getProductColors,
    getSpecificProduct,
    getSizeVariants,
    getProducts
  }
})